import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "p-2.5 bg-[#22282F]/10 rounded-xl" }
const _hoisted_5 = { class: "flex flex-wrap gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" }
const _hoisted_9 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-4 mb-6" }
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3" }
const _hoisted_11 = { class: "relative lg:col-span-2" }
const _hoisted_12 = ["label"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-3 mt-3" }
const _hoisted_16 = {
  key: 0,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-16"
}
const _hoisted_17 = {
  key: 1,
  class: "bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-3"
}
const _hoisted_18 = { class: "text-sm text-red-600 mt-1" }
const _hoisted_19 = {
  key: 2,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm overflow-hidden"
}
const _hoisted_20 = { class: "overflow-x-auto" }
const _hoisted_21 = { class: "w-full text-sm" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "py-3 px-4 align-top" }
const _hoisted_24 = { class: "text-dashboard-text font-medium" }
const _hoisted_25 = { class: "text-xs text-dashboard-muted" }
const _hoisted_26 = { class: "py-3 px-4 align-top" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_28 = { class: "w-8 h-8 rounded-full bg-[#22282F]/10 flex items-center justify-center text-xs font-semibold text-[#22282F]" }
const _hoisted_29 = { class: "min-w-0" }
const _hoisted_30 = { class: "text-dashboard-text font-medium truncate" }
const _hoisted_31 = {
  key: 1,
  class: "text-dashboard-muted italic text-xs"
}
const _hoisted_32 = { class: "py-3 px-4 align-top" }
const _hoisted_33 = { class: "flex items-center gap-2" }
const _hoisted_34 = { class: "flex flex-col gap-0.5" }
const _hoisted_35 = { class: "text-dashboard-text font-medium" }
const _hoisted_36 = { class: "flex items-center gap-1.5" }
const _hoisted_37 = { class: "py-3 px-4 align-top" }
const _hoisted_38 = {
  key: 1,
  class: "inline-flex items-center gap-1 px-2 py-1 bg-gray-100 rounded text-xs text-gray-700"
}
const _hoisted_39 = {
  key: 1,
  class: "text-dashboard-muted italic text-xs"
}
const _hoisted_40 = { class: "py-3 px-4 align-top" }
const _hoisted_41 = {
  key: 0,
  class: "font-mono text-xs text-dashboard-text"
}
const _hoisted_42 = {
  key: 1,
  class: "text-dashboard-muted italic text-xs"
}
const _hoisted_43 = { class: "py-3 px-4 align-top" }
const _hoisted_44 = { class: "py-3 px-4 text-center align-top" }
const _hoisted_45 = { class: "border-t border-dashboard-border px-4 py-3 flex items-center justify-between gap-4 flex-wrap" }
const _hoisted_46 = { class: "text-sm text-dashboard-muted" }
const _hoisted_47 = { class: "ml-3" }
const _hoisted_48 = { class: "flex items-center gap-2" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 3,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-12 text-center"
}
const _hoisted_52 = { class: "w-16 h-16 bg-dashboard-bg rounded-full flex items-center justify-center mx-auto mb-4" }
const _hoisted_53 = { class: "text-dashboard-muted text-sm" }

import { ref, computed, onMounted, watch } from 'vue'
import {
  History, Activity, Search, RefreshCw, AlertCircle, X, Users, AlertTriangle,
  ShieldAlert, Mail, Info, Download, ChevronRight, ListChecks, Archive as ArchiveIcon,
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AuditLogDetailPanel from '@/components/audit/AuditLogDetailPanel.vue'
import StatCard from '@/components/audit/StatCard.vue'
import { apiFetch, API_BASE_URL } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import {
  ACTION_GROUPS, SOURCE_META,
  getActionLabel, getDomainMeta, getTargetLabel,
  getSeverityMeta, getSourceMeta,
  formatDateTime, formatRelative,
} from '@/utils/auditMeta'
import type { AuditLogEntry } from '@/utils/auditMeta'


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditView',
  setup(__props) {

const toast = useToast()

const logs = ref<AuditLogEntry[]>([])
const loading = ref(false)
const error = ref('')
const selectedLog = ref<AuditLogEntry | null>(null)

// Filtres (state)
const searchQuery = ref('')
const filterAction = ref('')
const filterSeverity = ref('')
const filterSource = ref('')
const filterTargetType = ref('')
const filterDateFrom = ref('')
const filterDateTo = ref('')
const filterIp = ref('')
const filterRequestId = ref('')
const filterUserId = ref<number | string>('')

// Pagination
const perPage = ref(50)
const pagination = ref({ page: 1, per_page: 50, total: 0, pages: 0 })

const hasActiveFilters = computed(() =>
  Boolean(
    searchQuery.value || filterAction.value || filterSeverity.value || filterSource.value ||
    filterTargetType.value || filterDateFrom.value || filterDateTo.value || filterIp.value ||
    filterRequestId.value || filterUserId.value,
  ),
)

const severityCounts = computed(() => {
  const c = { info: 0, warning: 0, critical: 0 }
  for (const l of logs.value) c[l.severity] = (c[l.severity] || 0) + 1
  return c
})

const uniqueUsersCount = computed(() =>
  new Set(logs.value.filter(l => l.user).map(l => l.user!.id)).size,
)

function getUserInitials(user: { full_name: string; username: string }): string {
  const name = user.full_name || user.username
  const parts = name.trim().split(/\s+/).slice(0, 2)
  return parts.map(p => p[0]?.toUpperCase() || '').join('') || '?'
}

function buildQueryString(forCsv = false): string {
  const params = new URLSearchParams()
  if (searchQuery.value.trim()) params.set('q', searchQuery.value.trim())
  if (filterAction.value) params.set('action', filterAction.value)
  if (filterSeverity.value) params.set('severity', filterSeverity.value)
  if (filterSource.value) params.set('source', filterSource.value)
  if (filterTargetType.value) params.set('target_type', filterTargetType.value)
  if (filterDateFrom.value) params.set('from', `${filterDateFrom.value}T00:00:00`)
  if (filterDateTo.value) params.set('to', `${filterDateTo.value}T23:59:59`)
  if (filterIp.value) params.set('ip', filterIp.value)
  if (filterRequestId.value) params.set('request_id', filterRequestId.value)
  if (filterUserId.value) params.set('user_id', String(filterUserId.value))
  if (forCsv) {
    params.set('format', 'csv')
  } else {
    params.set('page', String(pagination.value.page))
    params.set('per_page', String(perPage.value))
  }
  return params.toString()
}

async function fetchLogs() {
  loading.value = true
  error.value = ''
  try {
    const qs = buildQueryString()
    const result = await apiFetch(`/api/admin/audit-logs/?${qs}`)
    logs.value = result.data || []
    pagination.value = result.pagination || { page: 1, per_page: perPage.value, total: 0, pages: 0 }
  } catch (e: any) {
    error.value = e?.message || 'Erreur lors du chargement'
    toast.error('Erreur', error.value)
  } finally {
    loading.value = false
  }
}

function clearFilters() {
  searchQuery.value = ''
  filterAction.value = ''
  filterSeverity.value = ''
  filterSource.value = ''
  filterTargetType.value = ''
  filterDateFrom.value = ''
  filterDateTo.value = ''
  filterIp.value = ''
  filterRequestId.value = ''
  filterUserId.value = ''
  pagination.value.page = 1
  fetchLogs()
}

function goPrev() {
  if (pagination.value.page > 1) {
    pagination.value.page--
    fetchLogs()
  }
}

function goNext() {
  if (pagination.value.page < pagination.value.pages) {
    pagination.value.page++
    fetchLogs()
  }
}

function downloadCsv() {
  const qs = buildQueryString(true)
  // Le backend stream le CSV ; on déclenche un téléchargement natif avec
  // cookies de session (window.location respecte les cookies).
  window.open(`${API_BASE_URL}/api/admin/audit-logs/?${qs}`, '_blank')
}

// Re-fetch automatique quand filtres serveur changent
watch(
  [filterAction, filterSeverity, filterSource, filterTargetType, filterDateFrom, filterDateTo, filterIp, filterRequestId, filterUserId],
  () => {
    pagination.value.page = 1
    fetchLogs()
  },
)

// Recherche plein-texte : debounce pour ne pas requêter à chaque frappe
let searchDebounce: ReturnType<typeof setTimeout> | undefined
watch(searchQuery, () => {
  if (searchDebounce) clearTimeout(searchDebounce)
  searchDebounce = setTimeout(() => {
    pagination.value.page = 1
    fetchLogs()
  }, 350)
})

onMounted(fetchLogs)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(History), { class: "w-6 h-6 text-[#22282F]" })
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", null, [
              _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-dashboard-text" }, "Audit & Traçabilité"),
              _createElementVNode("p", { class: "text-sm text-dashboard-muted mt-0.5" }, " Qui a fait quoi, sur quoi, quand, comment et depuis où. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/audit/archives",
              class: "px-4 py-2 bg-white border border-dashboard-border text-dashboard-text rounded-lg text-sm font-medium hover:bg-dashboard-bg transition-colors flex items-center gap-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArchiveIcon), { class: "w-4 h-4" }),
                _cache[15] || (_cache[15] = _createTextVNode(" Archives MinIO "))
              ]),
              _: 1,
              __: [15]
            }),
            _createElementVNode("button", {
              onClick: downloadCsv,
              disabled: loading.value,
              class: "px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm font-medium hover:bg-[#22282F]/90 transition-colors disabled:opacity-50 flex items-center gap-2",
              title: "Export CSV (utilise le streaming backend, supporte de grandes quantités)"
            }, [
              _createVNode(_unref(Download), { class: "w-4 h-4" }),
              _cache[16] || (_cache[16] = _createTextVNode(" Export CSV "))
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              onClick: fetchLogs,
              disabled: loading.value,
              class: "p-2 bg-white border border-dashboard-border rounded-lg hover:bg-dashboard-bg disabled:opacity-50",
              title: "Actualiser"
            }, [
              _createVNode(_unref(RefreshCw), {
                class: _normalizeClass(['w-4 h-4', loading.value && 'animate-spin'])
              }, null, 8, ["class"])
            ], 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(StatCard, {
            label: "Entrées chargées",
            value: logs.value.length.toString(),
            icon: _unref(Activity),
            tone: "slate"
          }, null, 8, ["value", "icon"]),
          _createVNode(StatCard, {
            label: "Avertissements",
            value: severityCounts.value.warning.toString(),
            icon: _unref(AlertTriangle),
            tone: "amber"
          }, null, 8, ["value", "icon"]),
          _createVNode(StatCard, {
            label: "Critiques",
            value: severityCounts.value.critical.toString(),
            icon: _unref(ShieldAlert),
            tone: "red"
          }, null, 8, ["value", "icon"]),
          _createVNode(StatCard, {
            label: "Utilisateurs uniques",
            value: uniqueUsersCount.value.toString(),
            icon: _unref(Users),
            tone: "indigo"
          }, null, 8, ["value", "icon"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-dashboard-muted" }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                placeholder: "Recherche (utilisateur, IP, request_id…)",
                class: "w-full pl-9 pr-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F]"
              }, null, 512), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterAction).value = $event)),
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F]"
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "Toutes les actions", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ACTION_GROUPS), (group) => {
                return (_openBlock(), _createElementBlock("optgroup", {
                  key: group.domain,
                  label: group.label
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.actions, (a) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: a,
                      value: a
                    }, _toDisplayString(_unref(getActionLabel)(a)), 9, _hoisted_13))
                  }), 128))
                ], 8, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, filterAction.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterSeverity).value = $event)),
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F]"
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("option", { value: "" }, "Toute sévérité", -1),
              _createElementVNode("option", { value: "info" }, "Information", -1),
              _createElementVNode("option", { value: "warning" }, "Avertissement", -1),
              _createElementVNode("option", { value: "critical" }, "Critique", -1)
            ]), 512), [
              [_vModelSelect, filterSeverity.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterSource).value = $event)),
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F]"
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "Toutes sources", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SOURCE_META), (meta, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: key,
                  value: key
                }, _toDisplayString(meta.label), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, filterSource.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterTargetType).value = $event)),
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F]"
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("option", { value: "" }, "Toute cible", -1),
              _createElementVNode("option", { value: "courrier" }, "Courrier", -1),
              _createElementVNode("option", { value: "note" }, "Note", -1),
              _createElementVNode("option", { value: "affectation" }, "Affectation", -1),
              _createElementVNode("option", { value: "user" }, "Utilisateur", -1),
              _createElementVNode("option", { value: "role" }, "Rôle", -1),
              _createElementVNode("option", { value: "cable" }, "Câble", -1)
            ]), 512), [
              [_vModelSelect, filterTargetType.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterDateFrom).value = $event)),
              type: "date",
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm",
              placeholder: "Du"
            }, null, 512), [
              [_vModelText, filterDateFrom.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterDateTo).value = $event)),
              type: "date",
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm",
              placeholder: "Au"
            }, null, 512), [
              [_vModelText, filterDateTo.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterIp).value = $event)),
              type: "text",
              placeholder: "Adresse IP exacte",
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm"
            }, null, 512), [
              [_vModelText, filterIp.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filterRequestId).value = $event)),
              type: "text",
              placeholder: "UUID request_id",
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm font-mono"
            }, null, 512), [
              [_vModelText, filterRequestId.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filterUserId).value = $event)),
              type: "number",
              placeholder: "ID utilisateur",
              class: "px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm"
            }, null, 512), [
              [_vModelText, filterUserId.value]
            ]),
            (hasActiveFilters.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: clearFilters,
                  class: "px-3 py-2 text-dashboard-muted hover:text-dashboard-text text-sm flex items-center gap-2 justify-center border border-dashed border-dashboard-border rounded-lg hover:bg-dashboard-bg"
                }, [
                  _createVNode(_unref(X), { class: "w-4 h-4" }),
                  _cache[21] || (_cache[21] = _createTextVNode(" Réinitialiser "))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (loading.value && logs.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[22] || (_cache[22] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", { class: "w-10 h-10 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin mx-auto mb-4" }),
                _createElementVNode("p", { class: "text-dashboard-muted" }, "Chargement des logs…")
              ], -1)
            ])))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_unref(AlertCircle), { class: "w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" }),
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("p", { class: "font-medium text-red-800" }, "Erreur de chargement", -1)),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(error.value), 1)
                ])
              ]))
            : (logs.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                      _cache[24] || (_cache[24] = _createElementVNode("thead", { class: "bg-dashboard-bg border-b border-dashboard-border text-xs uppercase tracking-wide text-dashboard-muted" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold w-44" }, "Date"),
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold" }, "Utilisateur"),
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold" }, "Action"),
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold" }, "Cible"),
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold w-32" }, "IP"),
                          _createElementVNode("th", { class: "text-left py-3 px-4 font-semibold w-24" }, "Source"),
                          _createElementVNode("th", { class: "text-center py-3 px-4 font-semibold w-12" })
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: log.id,
                            onClick: ($event: any) => (selectedLog.value = log),
                            class: _normalizeClass([
                  'border-t border-dashboard-border hover:bg-dashboard-bg cursor-pointer transition-colors border-l-4',
                  _unref(getSeverityMeta)(log.severity).ring,
                  selectedLog.value?.id === log.id && 'bg-blue-50/40',
                ])
                          }, [
                            _createElementVNode("td", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(formatDateTime)(log.created_at)), 1),
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(formatRelative)(log.created_at)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_26, [
                              (log.user)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(getUserInitials(log.user)), 1),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("p", _hoisted_30, _toDisplayString(log.user.full_name), 1),
                                      _createVNode(_component_router_link, {
                                        to: `/audit/user/${log.user.id}`,
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                        class: "text-xs text-blue-600 hover:underline"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("@" + _toDisplayString(log.user.username), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_31, "— Système / anonyme —"))
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getDomainMeta)(log.action).icon), {
                                  class: _normalizeClass(['w-4 h-4', 'text-' + 'dashboard-muted'])
                                })),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(getActionLabel)(log.action)), 1),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['text-[10px] px-1.5 py-0.5 rounded font-medium', _unref(getDomainMeta)(log.action).badge])
                                    }, _toDisplayString(_unref(getDomainMeta)(log.action).label), 3),
                                    (log.severity !== 'info')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(['text-[10px] px-1.5 py-0.5 rounded font-medium', _unref(getSeverityMeta)(log.severity).badge])
                                        }, _toDisplayString(_unref(getSeverityMeta)(log.severity).label), 3))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_37, [
                              (log.courrier_id || log.target_id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (log.courrier_id || log.target_type === 'courrier')
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 0,
                                          to: `/audit/courrier/${log.courrier_id || log.target_id}`,
                                          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                                          class: "inline-flex items-center gap-1 px-2 py-1 bg-indigo-50 text-indigo-700 rounded text-xs hover:bg-indigo-100 border border-indigo-200"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Mail), { class: "w-3 h-3" }),
                                            _createTextVNode(" Courrier #" + _toDisplayString(log.courrier_id || log.target_id), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ListChecks)), { class: "w-3 h-3" })),
                                          _createTextVNode(" " + _toDisplayString(_unref(getTargetLabel)(log.target_type)) + " #" + _toDisplayString(log.target_id), 1)
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, "—"))
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              (log.ip_address)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(log.ip_address), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_42, "—"))
                            ]),
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("span", {
                                class: _normalizeClass(['inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium', _unref(getSourceMeta)(log.source).badge])
                              }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getSourceMeta)(log.source).icon), { class: "w-3 h-3" })),
                                _createTextVNode(" " + _toDisplayString(log.source), 1)
                              ], 2)
                            ]),
                            _createElementVNode("td", _hoisted_44, [
                              _createVNode(_unref(ChevronRight), { class: "w-4 h-4 text-dashboard-muted inline" })
                            ])
                          ], 10, _hoisted_22))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[25] || (_cache[25] = _createTextVNode(" Page ")),
                      _createElementVNode("strong", null, _toDisplayString(pagination.value.page), 1),
                      _cache[26] || (_cache[26] = _createTextVNode(" / ")),
                      _createElementVNode("strong", null, _toDisplayString(pagination.value.pages || 1), 1),
                      _createElementVNode("span", _hoisted_47, _toDisplayString(pagination.value.total) + " entrée(s) au total", 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((perPage).value = $event)),
                        onChange: fetchLogs,
                        class: "px-2 py-1 border border-dashboard-border rounded text-sm"
                      }, _cache[27] || (_cache[27] = [
                        _createElementVNode("option", { value: 25 }, "25 / page", -1),
                        _createElementVNode("option", { value: 50 }, "50 / page", -1),
                        _createElementVNode("option", { value: 100 }, "100 / page", -1),
                        _createElementVNode("option", { value: 200 }, "200 / page", -1)
                      ]), 544), [
                        [
                          _vModelSelect,
                          perPage.value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        onClick: goPrev,
                        disabled: pagination.value.page <= 1,
                        class: "px-3 py-1 border border-dashboard-border rounded text-sm hover:bg-dashboard-bg disabled:opacity-50 disabled:cursor-not-allowed"
                      }, "Précédent", 8, _hoisted_49),
                      _createElementVNode("button", {
                        onClick: goNext,
                        disabled: pagination.value.page >= pagination.value.pages,
                        class: "px-3 py-1 border border-dashboard-border rounded text-sm hover:bg-dashboard-bg disabled:opacity-50 disabled:cursor-not-allowed"
                      }, "Suivant", 8, _hoisted_50)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_unref(History), { class: "w-8 h-8 text-dashboard-muted" })
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-lg font-semibold text-dashboard-text mb-1" }, "Aucun log trouvé", -1)),
                  _createElementVNode("p", _hoisted_53, _toDisplayString(hasActiveFilters.value ? 'Essayez d\'élargir vos filtres.' : 'Aucune activité enregistrée pour le moment.'), 1)
                ]))
      ]),
      (selectedLog.value)
        ? (_openBlock(), _createBlock(AuditLogDetailPanel, {
            key: 0,
            log: selectedLog.value,
            onClose: _cache[13] || (_cache[13] = ($event: any) => (selectedLog.value = null))
          }, null, 8, ["log"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})